import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pictos/divers/logo_header_mobile.png")